import styled, { css } from 'styled-components';
import { Link } from 'react-scroll';
import { Swiper } from 'swiper/react';
import { Lupe } from '../../../assets/svgs/lupe';

export const NewMenuChangeItemType = styled.div`
  z-index: 10;
  background: var(--primary-color);
`;

export const NewMenuChangeItemTypeTop = styled.div`
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: var(--primary-color);
  padding: 12px var(--grid-margin-space) 8px var(--grid-margin-space);
  & > h2 {
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  ${(props) => props.$isSticky && css`
    padding: 15px var(--grid-margin-space);

    & > h2 {
      font-size: 14px;
      line-height: 16px;
    }
  `}
`;

export const NewMenuChangeItemTypeItems = styled.div`
  width: 100%;
  z-index: 10;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  background: var(--primary-color);
  padding: 12px var(--grid-margin-space) 22px var(--grid-margin-space);
  ${(props) => props.$isSticky && css`
    background: #FFF;
    padding: 12px var(--grid-margin-space);
  `}
`;

export const NewMenuChangeItemTypeSlide = styled(Swiper)`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  align-items: center;
  background: var(--primary-color);
  .swiper-wrapper {
    display: flex;
  }
  ${(props) => props.$isSticky && css`
    background: #FFF;
  `}
`;

export const NewMenuChangeItemTypeLink = styled(Link)`
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 5px 10px;
  margin-right: 7px;
  border-radius: 4px;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  text-transform: capitalize;

  color: #FFF;
  border: 1px solid #FFF;
  background: var(--primary-color);

  &.active {
    color: #FFF;
    background: var(--primary-color);
  }
  ${(props) => props.$isSticky && css`
    background: #FFF;
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
  `}
`;

export const DisplaySearch = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    color: #FFFFFF;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  a {
    height: 20px;
  }
`;

export const InputSearch = styled.input`
  width: 100%;
  height: 40px;
  display: flex;
  padding: 0 20px;
  border-radius: 4px;
  position: relative;
  border: 1px solid var(--default-gray);
  &:focus {
    border: 1px solid var(--primary-color);
    box-shadow: 0 0 7px 0 var(--primary-color);
  }
`;

export const ContainerSearch = styled.div`
  z-index: 1;
  display: flex;
  margin-top: 10px;
  position: relative;
  align-items: center;
  a {
    height: 24px;
    display: flex;
    font-size: 24px;
    margin-right: 10px;
  }
  ${(props) => props.$isSticky && css`
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 15%);
  `}
`;

export const ResultsNumberContainer = styled.div`
  display: flex;
  padding: 8px 0;
  margin: 0 -20px;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
  border: 1px solid var(--default-gray);
`;

export const ResultsNumber = styled.span`
  font-size: 12px;
  text-align: center;
  color: var(--text-secondary-color);
`;

export const LupeStyled = styled(Lupe)`
  right: 20px;
  width: 18px;
  height: 18px;
  position: absolute;
`;
